import styles from './styles.module.css'

import React, { useCallback } from 'react'

import type { TerritoryTis } from '@disco/types/types/rights-data'
import { Checkbox, Flex, Text, Tooltip } from 'components/ds'
import cl from 'clsx'

import { TERRITORIES } from '../territories'

type Props = {
  appliedTis: Set<TerritoryTis>
  availableTis: Set<TerritoryTis>
  onChange: (next: Set<TerritoryTis>) => void
}

const TerritoryFilter = (props: Props): React.ReactElement => {
  const { appliedTis, availableTis, onChange } = props

  const toggle = useCallback(
    (tis: TerritoryTis) => {
      const next = new Set(appliedTis)
      if (next.has(tis)) {
        next.delete(tis)
      } else {
        next.add(tis)
      }
      onChange(next)
    },
    [appliedTis, onChange],
  )

  return (
    <Flex align="center" gap="4" wrap="wrap">
      {TERRITORIES.map(territory => {
        const hasData = availableTis.has(territory.tis)
        const isChecked = hasData && appliedTis.has(territory.tis)

        const item = (
          <Flex
            key={territory.tis}
            align="center"
            gap="2"
            className={cl(styles.territory, !hasData && styles.disabled)}
            onClick={hasData ? () => toggle(territory.tis) : undefined}
          >
            <Text size="2" weight="bold">
              {territory.code}
            </Text>
            <Checkbox checked={isChecked} disabled={!hasData} />
          </Flex>
        )

        if (!hasData) {
          return (
            <Tooltip key={territory.tis} content="Rights Unavailable">
              {item}
            </Tooltip>
          )
        }
        return item
      })}
    </Flex>
  )
}

export default TerritoryFilter
